(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-list.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-list.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback;
const ReactButton = svs.ui.ReactButton;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const fetchCompetitionHighscore = svs.components.marketplaceCompetition.services.actions.highscoreResultActions.fetchCompetitionHighscore;
const _ReactRedux2 = ReactRedux,
  useSelector = _ReactRedux2.useSelector;
const ReactIntersectionObserver = svs.components.lbUtils.intersectionObserver.ReactIntersectionObserver;
const _svs$components$marke = svs.components.marketplaceCompetition.routeResult.highscore,
  HighscoreContext = _svs$components$marke.HighscoreContext,
  HighScoreListItem = _svs$components$marke.HighScoreListItem;
const _svs$components$marke2 = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors,
  selectCompetitionResult = _svs$components$marke2.selectCompetitionResult,
  selectCompetitionResultPending = _svs$components$marke2.selectCompetitionResultPending,
  selectCompetitionResultComplete = _svs$components$marke2.selectCompetitionResultComplete;
const useCompetitionId = svs.components.marketplaceCompetition.competitionContext.useCompetitionId;
const _svs$components$marke3 = svs.components.marketplaceCompetition.services.hooks,
  useCompetitionType = _svs$components$marke3.useCompetitionType,
  useGetCompetitionResultCount = _svs$components$marke3.useGetCompetitionResultCount;
const HighscoreList = () => {
  var _useGetCompetitionRes;
  const _useContext = useContext(HighscoreContext),
    typeDescription = _useContext.typeDescription,
    type = _useContext.type,
    searchTerm = _useContext.searchTerm,
    count = _useContext.count,
    offset = _useContext.offset,
    setOffset = _useContext.setOffset;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    autoLoadActive = _useState2[0],
    setAutoLoadActive = _useState2[1];
  const dispatch = useDispatch();
  const competitionId = useCompetitionId();
  const list = useSelector(state => selectCompetitionResult(state, competitionId, type, 30));
  const totalCount = (_useGetCompetitionRes = useGetCompetitionResultCount({
    competitionId,
    type
  })) !== null && _useGetCompetitionRes !== void 0 ? _useGetCompetitionRes : 0;
  const listIsPending = useSelector(state => selectCompetitionResultPending(state, competitionId, type));
  const resultDone = useSelector(state => selectCompetitionResultComplete(state, competitionId, type));
  const competitionType = useCompetitionType(competitionId);
  useEffect(() => {
    setAutoLoadActive(false);
  }, [type, searchTerm]);
  useEffect(() => {
    dispatch(fetchCompetitionHighscore({
      competitionId,
      payloadType: type,
      count,
      offset,
      search: searchTerm,
      type: competitionType
    }));
  }, [competitionId, count, dispatch, offset, type, searchTerm, competitionType]);
  const loadMoreCallback = useCallback(() => {
    setOffset(offset + count);
  }, [count, offset, setOffset]);
  const intersectionCallback = useCallback(_ref => {
    let isIntersecting = _ref.isIntersecting;
    if (isIntersecting) {
      loadMoreCallback();
    }
  }, [loadMoreCallback]);
  const noResults = !list || list.length < 1;
  if (noResults) {
    return React.createElement("div", {
      className: "highscore-list-container f-center"
    }, React.createElement("p", null, "Inga resultat hittades"));
  }
  const shouldShowMoreButton = !noResults && !resultDone && !listIsPending;
  return React.createElement("div", {
    className: "highscore-list-container"
  }, offset > 0 && React.createElement("span", {
    "aria-live": "polite",
    className: "sr-only"
  }, "".concat(offset, " fler ").concat(typeDescription, " tillagda i listan. Totalt ").concat(list.length, " av ").concat(totalCount, " visas.")), React.createElement("div", {
    className: "highscore-header-container"
  }, React.createElement("span", {
    className: "highscore-header-position"
  }, React.createElement("abbr", {
    title: "Position"
  }, "Pos.")), React.createElement("span", {
    className: "highscore-header-type"
  }, "".concat(typeDescription, " (").concat(totalCount, " st)")), React.createElement("span", {
    className: "highscore-header-drawpoints"
  }, React.createElement("abbr", {
    title: "Omg\xE5ngens po\xE4ng"
  }, "Omg.")), React.createElement("span", {
    className: "highscore-header-totalpoints"
  }, React.createElement("abbr", {
    title: "Totalt antal po\xE4ng"
  }, "Tot."))), React.createElement("div", {
    className: "highscore-body-container"
  }, list && list.map(el => React.createElement(HighScoreListItem, {
    competitionId: competitionId,
    el: el,
    key: el.uid,
    type: type
  }))), React.createElement(ReactIntersectionObserver, {
    isObserving: shouldShowMoreButton && autoLoadActive,
    onIntersection: intersectionCallback
  }, shouldShowMoreButton && React.createElement(ReactButton, {
    "aria-label": "H\xE4mta 20 fler ".concat(typeDescription, " till listan"),
    className: "btn-highscore-more",
    inverted: true,
    onClick: () => {
      loadMoreCallback();
      setAutoLoadActive(true);
    }
  }, "Visa fler")));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreList', HighscoreList);

 })(window);